export default "__VITE_ASSET__BmObKSxB__"